import React, { useEffect, useRef, useState } from "react";
import bgvideo from "../../images/bgvideo.mp4";
import { Link, useLocation } from "react-router-dom";
import logo from "../../images/logo.png";
import { getBaseUrl } from "../common/BaseUrl";
const Blockpage = () => {
  const videoRef = useRef(null);
  let base_url = getBaseUrl();
  const location = useLocation();
  const myData = location.state?.myData;
  const [isTransitioning, setIsTransitioning] = useState(false);
  const handleVideoEnd = () => {
    // Begin the black screen transition effect
    setIsTransitioning(true);
    // Delay to show the black screen for 1 second, then restart video smoothly
    setTimeout(() => {
      if (videoRef.current) {
        videoRef.current.currentTime = 0; // Reset to the start
        videoRef.current.play(); // Start playing from the beginning
      }
      setIsTransitioning(false); // Remove black screen transition
    }, 100); // Show black screen for 1 second
  };

  useEffect(() => {
    const video = videoRef.current;

    if (video) {
      // Listen for the video's `timeupdate` to detect nearing end
      const handleTimeUpdate = () => {
        if (video.duration - video.currentTime <= 1) {
          setIsTransitioning(true); // Start fading out near the end
        }
      };

      video.addEventListener("timeupdate", handleTimeUpdate);
      video.addEventListener("ended", handleVideoEnd); // Trigger on end

      // Automatically play the video on component load
      video.play();

      return () => {
        video.removeEventListener("timeupdate", handleTimeUpdate);
        video.removeEventListener("ended", handleVideoEnd);
      };
    }
  }, []);
  return (
    <div className="theme-color-1">
      <div className="mainLoginbg">
        <div style={{ position: "relative", overflow: "hidden" }}>
          {/* Video element */}
          <video
            ref={videoRef}
            playsInline
            loop={false} // Set loop to false to control replay manually
            muted
            autoPlay
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              opacity: !isTransitioning ? 1 : 0,
              transition: "opacity 1s ease-in-out",
            }}
          >
            <source src={bgvideo} type="video/mp4" />
          </video>

          {/* Black screen overlay for transition */}
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "black",
              opacity: isTransitioning ? 1 : 0,
              transition: "opacity 1s ease-in-out", // Smooth transition for fade effect
              pointerEvents: "none", // Allow clicks to pass through
            }}
          />
        </div>
        <section className="loginRegisterform maxwidth">
          <div className="container">
            <div className="row justify-content-center">
              <div class="blocked-box shadow-lg">
                <Link to={`${base_url}`}>
                  <img src={logo} alt="" className="logo" />
                </Link>

                <div class="icon">🚫</div>

               <div className="sec_title text-left"   dangerouslySetInnerHTML={{
                    __html: myData
                  }}>
                </div>

                <Link to={`${base_url}`} class="btn btn-home">
                  TO HOME PAGE
                </Link>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Blockpage;
